<template>
  <div id="app-wrapper" class="background-waiting">
    <main class="main">
      <div>
        <div class="flex flex-column items-center">
          <div class="flex justify-center w-30 pb2">
            <img class="top-margin-2" src="../assets/logo-Waiting.png" alt="BeatHey Logo">
          </div>
          <div class="mv2">
            <h1 class="waiting-msg">En breve serás redirigido a BeatHey!</h1>
          </div>
          <div class="mv2">
            <clip-loader :loading="loading" :color="color" :size="size"></clip-loader>
          </div>        
        </div>
      </div>
    </main>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

  export default {
    name: 'waiting',
    data () {
      return {
        loading: true,
        color: '#ffffff',
        size: '65px'
      }
    },
    components: {
      ClipLoader
    },
    computed: {
      ...mapGetters('user', [
        'isLoggedIn'
      ])
    },
    created () {
      this.providerLogin()
    },
    methods: {
      ...mapActions('user', [
        'loginByMsisdn',
        'autologinRecurrentEntel'
      ]),
      providerLogin () {
        const provider = this.$route.params.provider
        if (provider === 'entel') {
          let providerCountry = this.$route.query.country ? this.$route.query.country : 'PER'
          localStorage.setItem('providerCountry', providerCountry)
          if (this.$route.query.msfw) {
            let route = this.$router.resolve({ name: 'provider-tyc' })
            this.autologinRecurrentEntel({iterations: 20, interval: 5, msisdn: this.$route.query.msfw, provider: provider, enc: true, route: route.href})
              .then((e) => {
              })
              .catch(() => {
              })
          }
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '~@/variables.scss';

  @font-face {
    font-family: 'Titillium Web';
    src: url('../assets/fonts/TitilliumWeb-Bold.eot');
    src: url('../assets/fonts/TitilliumWeb-Bold.eot?#iefix') format('embedded-opentype'),
    url('../assets/fonts/TitilliumWeb-Bold.woff2') format('woff2'),
    url('../assets/fonts/TitilliumWeb-Bold.woff') format('woff'),
    url('../assets/fonts/TitilliumWeb-Bold.ttf') format('truetype'),
    url('../assets/fonts/TitilliumWeb-Bold.svg#TitilliumWeb-Bold') format('svg');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: 'Titillium Web';
    src: url('../assets/fonts/TitilliumWeb-Regular.eot');
    src: url('../assets/fonts/TitilliumWeb-Regular.eot?#iefix') format('embedded-opentype'),
    url('../assets/fonts/TitilliumWeb-Regular.woff2') format('woff2'),
    url('../assets/fonts/TitilliumWeb-Regular.woff') format('woff'),
    url('../assets/fonts/TitilliumWeb-Regular.ttf') format('truetype'),
    url('../assets/fonts/TitilliumWeb-Regular.svg#TitilliumWeb-Regular') format('svg');
    font-weight: normal;
    font-style: normal;
  }
  body, html{
    height: 100%;
    width: 100%;
  }
  .background-waiting{
    background-image: url("/static/assets/Waiting-background.png");
    background-size: cover;
    background-position: center;
    height: 100% !important;
    width: 100%;
  }

  a, button, input, select, textarea {
    font-family: 'Titillium Web';
  }

  #app-wrapper {
    font-family: 'Titillium Web', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }

  .main {
    height: $main-height;
    width: 100vw;
  }
  .waiting-msg {
    text-align: center;
    color: white;
    font-size: 36px;
  }
  .top-margin-2 {
    margin-top: 50%;
  }
  ul {
    margin: 0;
  }

  .bg-primary {
    background-color: $primary-color;
  }

  .bg-secondary {
    background-color: $secondary-color;
  }

  .bg-accent {
    background-color: $accent-color;
  }

  .primary {
    color: $primary-color;
  }

  .secondary {
    color: $secondary-color;
  }

  .accent {
    color: $accent-color;
  }

  .btn {
    border: 0;
    box-sizing: border-box;
    line-height: 2;
    background-color: $primary-color;
    color: white;
  }

  .input {
    box-sizing: border-box;
    line-height: 2;
    border: 0;
    border-bottom: 1px solid #DDDEDF;
  }

  .error {
    border-bottom: 1px solid rgba(255, 0, 0, 0.7);
  }

  .total-height {
    height: $main-height
  }

  .background-center {
    background-position: center center;
  }

  .text-ellipsis {
    white-space: nowrap;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .vinyl-rotation {
    animation: 1.5s linear infinite rotation;
  }

  #style-scroll-bar::-webkit-scrollbar-track
  {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 8px;
    background-color:  #555555;
  }

  #style-scroll-bar::-webkit-scrollbar
  {
    width: 8px;
    background-color: #555555;
  }

  #style-scroll-bar::-webkit-scrollbar-thumb
  {
    border-radius: 8px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: $secondary-color;
  }
  @keyframes rotation {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .w-35 {
    width: 35%;
  }

  .w-15 {
    width: 15%;
  }

  .w-7 {
    width: 7%;
  }

  .w-3 {
    width: 3%;
  }

  .w-5 {
    width: 5%;
  }

  .w-95 {
    width: 95%;
  }

  .noselect {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;
    /* Non-prefixed version, currently
                                     supported by Chrome and Opera */
  }

</style>


// WEBPACK FOOTER //
// src/components/Waiting.vue